"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    TokenType["separator"] = "separator";
    TokenType["eol"] = "eol";
    TokenType["text"] = "text";
    TokenType["escaped"] = "escaped-text";
})(TokenType || (exports.TokenType = TokenType = {}));
//# sourceMappingURL=types.js.map